import React, { useMemo } from "react";
import { faCircleT, faCircleMinus, faCircleXmark } from "web-fortawesome/npm/pro-light";
import { faCircleT as faCircleTSolid, faCircleXmark as faCircleXmarkSolid } from "web-fortawesome/npm/pro-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPresenceIconProps } from "./IPresenceIconProps";

/**
 * Presence Icon: Teams
 * @param props - props from interface IPresenceIconProps
 * @returns - the teams icon
 */
export const PresenceIconTeams = (props: IPresenceIconProps): React.ReactElement => {
	const icon = useMemo(() => {
		if (!props.callProtection && !props.lineForwarded) {
			if (props.type === "busy")
				return faCircleTSolid;
			else if (props.type === "absent")
				return faCircleMinus;
			else
				return faCircleT;
		} else if (props.callProtection) {
			if (props.type === "busy")
				return faCircleXmarkSolid;
			else
				return faCircleXmark;
		}
		return faCircleT;
	}, [props.type, props.callProtection, props.lineForwarded]);

	return (
		<FontAwesomeIcon
			className={props.className}
			icon={icon}
			fontSize={props.fontSize ?? 16}
			color={props.color ? props.color : `var(--presence-icon-type-${props.type ?? "free"})`}
		/>
	);
};
